<template>
  <div style="position: fixed;top:0;left: 50%;transform: translateX(-50%);z-index:99999;">
    <header>
      <img class="menus-btn" src="@/assets/imgs/top_menus.png" @click="menuShow" />
      <p class="title">文旅产业融合发展信息平台</p>
      <img class="menus-search" src="@/assets/imgs/top_search.png" @click="search" />
      <div class="menu-list" v-show="isMenuShow">
        <!-- 导航 -->
        <nav class="menu">
          <div class="menu-title">导航</div>
          <ul class="menu-ul clearfix">
            <li class="menu-li fl" v-for="item in navData" :key="item.id">
              <a :href="item.href">{{ item.name }}</a>
            </li>
            <li class="menu-li fl">
              <router-link :to="{ path: '/' }">文旅融合</router-link>
            </li>
            <li class="menu-li fl">
              <a href="http://h5.drcnet.com.cn/ydyl/">一带一路</a>
            </li>
          </ul>
        </nav>
        <!-- 文旅导航 -->
        <nav class="culture-menu">
          <div class="culture-menu-title">文旅产业融合发展信息平台导航</div>
          <!-- <div class="culture-menu-content">
            <router-link class="h1"
              :to="{ path: '/listLeafDynamic', query: { leafid: '4001', isProvince: $route.query.isProvince } }">最新推荐</router-link>
          </div> -->
          <div class="culture-menu-content" v-for="item in cultureNavData" :key="item.uid">
            <template v-if="item.uid != '4004'">
              <router-link class="h1"
                :to="{ path: '/listChannelDynamic', query: { uid: item.uid, isProvince: $route.query.isProvince } }">{{
                  item.text }}</router-link>
              <ul class="culture-menu-ul clearfix">
                <template v-for="ele in item.childList">
                  <li class="culture-menu-li fl" v-if="ele.uid != '400901' && ele.uid != '400301'" :key="ele.uid">

                    <router-link v-if="containThreeLevelMenu.includes(item.text)"
                      :to="{ path: '/listChannelDynamic', query: { uid: ele.uid, isProvince: $route.query.isProvince } }">{{
                        ele.text }}</router-link>
                    <router-link v-else
                      :to="{ path: '/listLeafDynamic', query: { leafid: ele.uid, isProvince: $route.query.isProvince } }">{{
                        ele.text }}</router-link>

                  </li>
                </template>
              </ul>
            </template>
          </div>
        </nav>
      </div>
    </header>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navData: [
        {
          id: 0,
          name: "综合版",
          href: "http://h5.drcnet.com.cn/integrated/"
        },
        {
          id: 1,
          name: "党政版",
          href: "http://h5.drcnet.com.cn/gov/"
        },
        {
          id: 2,
          name: "教育版",
          href: "http://h5.drcnet.com.cn/edu/"
        },
        {
          id: 3,
          name: "世经版",
          href: "http://h5.drcnet.com.cn/worldeconomy/"
        },
        {
          id: 4,
          name: "经济管理"
        },
        {
          id: 5,
          name: "战略新兴",
          href: "http://h5.drcnet.com.cn/emerging/"
        }
      ],
      cultureNavData: this.$store.state.menusData,
      isMenuShow: false,
      containThreeLevelMenu: ["文化产业", "旅游行业", "文化事业"]
    };
  },
  methods: {
    menuShow() {
      this.isMenuShow ? (this.isMenuShow = false) : (this.isMenuShow = true);
    },
    search() {
      this.$router.push({
        path: "/searchDynamic",
        query: { isProvince: this.$route.query.isProvince }
      });
    }
  },
  watch: {
    $route: {
      handler() {
        this.isMenuShow = false;
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
header {
  width: 750px;
  height: 90px;
  background: #a71312;
  position: relative;

  .menus-btn {
    width: 34px;
    height: 32px;
    position: absolute;
    left: 18px;
    top: 50%;
    transform: translateY(-50%);
  }

  .title {
    text-align: center;
    line-height: 90px;
    font-size: 34px;
    color: #ffffff;
  }

  .menus-search {
    width: 35px;
    height: 35px;
    position: absolute;
    right: 18px;
    top: 50%;
    transform: translateY(-50%);
  }
}

.menu-list {
  background: url(../assets/imgs/top_bg.jpg);
  height: calc(100vh - 90px);
  position: absolute;
  left: 0px;
  top: 90px;
  z-index: 999;
  overflow: auto;

  .menu {
    .menu-title {
      text-align: center;
      font-size: 32px;
      font-weight: bold;
      margin-top: 25px;
      margin-bottom: 12px;
    }

    .menu-ul {
      .menu-li {
        margin-top: 14px;
        margin-left: 14px;

        a {
          display: block;
          width: 171px;
          height: 52px;
          background: #ffffff;
          border-radius: 5px;
          line-height: 52px;
          font-size: 30px;
          text-align: center;
        }
      }
    }
  }

  .culture-menu {
    background: #fff;
    margin-top: 21px;
    padding: 0 12px;
    overflow: hidden;

    .culture-menu-title {
      font-size: 32px;
      font-weight: bold;
      text-align: center;
      margin-top: 40px;
      margin-bottom: 44px;
    }

    .culture-menu-content {
      margin-bottom: 40px;

      .h1 {
        position: relative;
        height: 33px;
        font-size: 32px;
        padding-left: 12px;

        &::after {
          display: block;
          content: "";
          width: 5px;
          height: 32px;
          background: #c01c1a;
          border-radius: 2px;
          position: absolute;
          left: 0;
          top: 6px;
        }
      }

      .culture-menu-ul {
        .culture-menu-li {
          height: 47px;
          background: #ffffff;
          border: 1px solid #dadada;
          border-radius: 23px;
          margin-top: 21px;
          margin-right: 15px;

          a {
            display: block;
            padding: 12px 26px;
            font-size: 24px;
          }
        }
      }
    }
  }
}
</style>
